/**
 * TrustBadges — strip above the Place Order button reminding the user
 * that checkout is safe / their food is fresh / returns are easy.
 *
 * Established trust at the moment of friction has the biggest conversion
 * impact in the funnel.
 */
import React from 'react';
import { Shield, Leaf, RotateCcw } from 'lucide-react';
import { css } from '../../design';

const TrustBadges: React.FC = () => (
  <div
    aria-label="Trust badges"
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 8,
      marginBottom: 12,
    }}
  >
    {[
      { icon: <Shield size={16} />, title: 'Secure checkout', sub: 'Encrypted · 100% safe' },
      { icon: <Leaf size={16} />,   title: 'Freshness guarantee', sub: 'Or your money back' },
      { icon: <RotateCcw size={16} />, title: 'Easy returns', sub: 'Damaged? 24-hour replace' },
    ].map((t, i) => (
      <div
        key={i}
        style={{
          background: css.color.surface,
          border: `1px solid ${css.color.border}`,
          borderRadius: 10,
          padding: '10px 10px',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ color: css.color.primary }}>{t.icon}</span>
        <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: css.color.text, lineHeight: 1.25 }}>
            {t.title}
          </span>
          <span style={{ fontSize: 11, color: css.color.textMuted, lineHeight: 1.25 }}>
            {t.sub}
          </span>
        </span>
      </div>
    ))}
  </div>
);

export default TrustBadges;

